import { firstCharToUpper, LocaleCode, productAvailabilityList } from '@anticatrade/shared';
import SlCheckbox from '@shoelace-style/shoelace/dist/react/checkbox/index.js';
import SlRadioGroup from '@shoelace-style/shoelace/dist/react/radio-group/index.js';
import SlRadio from '@shoelace-style/shoelace/dist/react/radio/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import { useContext } from 'react';
import { ProductContext, productContext } from './Product';
import { appContext } from '../../../context/AppContext';
import type { AppContext } from '../../../context/AppContext';
import { useTranslation } from 'react-i18next';

const ProductStatus = () => {
	const { t, i18n } = useTranslation();
	const { settings } = useContext(appContext as React.Context<AppContext>);
	const {
		visible,
		setVisible,
		availability,
		setAvailability,
		retrievedProduct,
		isCreation,
		productStatus,
	} = useContext(productContext as React.Context<ProductContext>);

	const onChangeAvailability = (e: any) => {
		setAvailability(e.target.value);
	};

	const onChangeVisible = () => {
		setVisible(!visible);
	};

	return (
		<div className='product__section product__section--status wrapped'>
			<div className='product__section-title-wrapper-status'>
				<div className='product__section-title product__section-title--status'>
					{t('Status')}
				</div>
				{productStatus === 'completed' &&
					retrievedProduct?.visible &&
					settings != null &&
					retrievedProduct?.texts[settings.languageCode as LocaleCode]?.slug && (
						<a
							className='product__showcase-link'
							href={`${import.meta.env.VITE_SHOWCASE_URL}/${settings.languageCode}/${retrievedProduct?.texts[settings.languageCode as LocaleCode].slug}`}
							target='_blank'
							rel='noopener noreferrer'
						>
							{t('View in the showcase')}
						</a>
					)}
			</div>
			{!isCreation && retrievedProduct != null && (
				<div>
					<div className='product__views'>
						<SlIcon name='eye' /> {t('Views')}: {retrievedProduct.views}
					</div>
					<div className='product__favorites'>
						<SlIcon name='heart' /> {t('Added to favorites')}:{' '}
						{retrievedProduct.favoritesCount}
					</div>
					<div className='product__timestamps'>
						<div className='product__created-at'>
							{t('Created')}:{' '}
							{new Date(retrievedProduct.createdAt).toLocaleString(i18n.language)}
						</div>
						<div className='product__updated-at'>
							{t('Last modified')}:{' '}
							{new Date(retrievedProduct.updatedAt).toLocaleString(i18n.language)}
						</div>
					</div>
				</div>
			)}
			<SlCheckbox className='product__visible' onSlChange={onChangeVisible} checked={visible}>
				{t('Visible in the showcase')}
			</SlCheckbox>
			<SlRadioGroup
				className='product__availability'
				label={t('Availability') + ':'}
				name='availability'
				onSlChange={onChangeAvailability}
				value={availability}
			>
				{productAvailabilityList.map((a) => (
					<SlRadio key={a} value={a}>
						{t(firstCharToUpper(a))}
					</SlRadio>
				))}
			</SlRadioGroup>
		</div>
	);
};

export { ProductStatus };
